/*tslint:disable */

import ActiveDirectoryAuthenticator from '../../adal/ActiveDirectoryAuthenticator';
import AdalConfigProvider from '../../adal/AdalConfigProvider';

var ADA = new ActiveDirectoryAuthenticator(new AdalConfigProvider());

export default class ApiConfig {
    public Token: string;

    getBaseUrl(defaultUrl: string, baseUrl?: string): string {
        let webapiHost = '';
        const hostname = window && window.location && window.location.hostname;
        switch (hostname) {
            case 'localhost':
                webapiHost = 'http://localhost:59034';
                break;
            case 'nedermanqsotest.azurewebsites.net':
                webapiHost = 'https://nedermanqsotest.azurewebsites.net/service';
                break;
            default:
                webapiHost = 'https://www.myquicksolutionsonline.com/service';
                break;
        }
        return webapiHost;
    }

    transformOptions(options: RequestInit) {
        if (options && options.headers) {
            if (!ADA.isAuthenticated) {
                ADA.login();
            }
            options.headers['Authorization'] = 'Bearer ' + ADA.accessToken;
        }
        /*
        if (options && options.headers) {
            options.headers['Authorization'] = 'Bearer ' + ApiTokenHandler.Token;
        }*/
        return Promise.resolve(options);
    }
}

export class ApiTokenHandler {
    public static Token: string;
}



// WEBPACK FOOTER //
// ./src/data/apiClient/apiConfig.ts